import { Action } from '@occc-app/rootRedux';

import types, { State } from './types';

import { default as offerTypes } from '../../../redux/types';

export const initialState: State = {
  dirty: false,
  error: null,
  errorMessages: [],
  expireAt: null,
  fulfillmentCount: 0,
  offerId: '',
  publishAt: null,
  submitting: false,
};

export function reducer(state: State = initialState, action: Action): State {
  switch (action.type) {
    case types.REQUEST_META_DATA_OK:
      return {
        ...initialState,
        expireAt: action.expireAt,
        fulfillmentCount: action.fulfillmentCount,
        offerId: action.offerId,
        publishAt: action.publishAt,
      };
    case types.RESET_INITIAL_META_DATA_STATE:
      return {
        ...state,
        ...action.metaData,
      };
    case offerTypes.CLEAR_OFFER_COMPONENT_STATE:
      return initialState;
  }
  return state;
}
